import { colors } from "./output.js";

/**
 * Refusal copy for the launch preconditions.
 *
 * These messages replace a failure that used to happen minutes later, in the
 * cloud, with nothing written anywhere a founder could read. Stopping here is
 * cheap; stopping there was invisible.
 */

/**
 * The refusal when no GitHub App credentials are on disk.
 *
 * Names exactly one remedy. The brain-less flag is deliberately absent: it is a
 * test affordance, and founder-facing copy does not offer a platform without
 * brain-backed workers.
 */
export function buildMissingCredsRefusal(credsPath: string): string {
  return (
    `\n${colors.error("✗")} No GitHub App credentials found at ${colors.field(credsPath)}.\n` +
    `  Your workers' brains are private repositories created through that App, so the install\n` +
    `  needs it before it starts.\n\n` +
    `  ${colors.hint("fix:")} m8t brain app-create --org <org>\n\n`
  );
}

/**
 * The refusal when the caller names an org that disagrees with the recorded credentials.
 *
 * Deterministic and local: no network call decides this, so it can refuse
 * without the risk of failing on a transient.
 */
export function buildOrgMismatchRefusal(args: { requested: string; recorded: string }): string {
  return (
    `\n${colors.error("✗")} The GitHub App on disk is installed on ${colors.field(args.recorded)}, ` +
    `but this launch asked for ${colors.field(args.requested)}.\n` +
    `  Brains would land in ${args.recorded}, not ${args.requested}.\n\n` +
    `  ${colors.hint("fix:")} m8t brain app-create --org ${args.requested}\n\n`
  );
}
